import Alert from '@customink/pigment-react/lib/components/Alert';
import { useAtomValue } from 'jotai';

import { WCIBMO_NAMES } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { hasValidZipCodeAtom } from '@/hooks/useValidateZipCode';
import { pageViewTag } from '@/utils/metrics';

export default function MissingQuantity({}) {
  const quantityType = useOrderQuantityType();
  const hasValidZipCode = useAtomValue(hasValidZipCodeAtom);

  if (hasValidZipCode) {
    pageViewTag(
      `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.ENTER_QUANTITIES}`,
    );
  }

  return (
    <Alert severity="error" sx={{ backgroundColor: '#FA3C00' }}>
      Please enter a quantity above.
    </Alert>
  );
}
